'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = require('../../components');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _GenderEqualityScoreLabel = require('./GenderEqualityScoreLabel.css');

var _GenderEqualityScoreLabel2 = _interopRequireDefault(_GenderEqualityScoreLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NULL_SENTINEL = -1.0;

var GenderEqualityScoreLabel = (_dec = (0, _reactCssModules2.default)(_GenderEqualityScoreLabel2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GenderEqualityScoreLabel, _Component);

  function GenderEqualityScoreLabel(props) {
    (0, _classCallCheck3.default)(this, GenderEqualityScoreLabel);
    return (0, _possibleConstructorReturn3.default)(this, (GenderEqualityScoreLabel.__proto__ || (0, _getPrototypeOf2.default)(GenderEqualityScoreLabel)).call(this, props));
  }

  (0, _createClass3.default)(GenderEqualityScoreLabel, [{
    key: 'render',
    value: function render() {
      var scoreStyle = function scoreStyle(__score) {
        var _score = _convert2.default.float(__score);
        if (_score < 10) {
          return 'percentile-10';
        } else if (_score < 20) {
          return 'percentile-20';
        } else if (_score < 30) {
          return 'percentile-30';
        } else if (_score < 40) {
          return 'percentile-40';
        } else if (_score < 50) {
          return 'percentile-50';
        } else if (_score < 60) {
          return 'percentile-60';
        } else if (_score < 70) {
          return 'percentile-70';
        } else if (_score < 80) {
          return 'percentile-80';
        } else if (_score < 90) {
          return 'percentile-90';
        } else if (_score <= 100) {
          return 'percentile-100';
        }
        return false;
      };

      // assign score values
      // assign tooltips
      var fund = this.props.fund;
      var gefType = this.props.gefType;
      var _id = fund.investment_vehicle_id || fund.fund_id;

      var scoreValue = fund[gefType];
      var notEmpty = _convert2.default.float(scoreValue) > NULL_SENTINEL;

      var score = null;
      var norm = null;
      var tip = null;
      var emptyTip = null;
      var units = null;
      var nth = null;

      var _div = "<div style='max-width:200px;font-weight:300;'>";
      var div_ = '</div>';

      var emptyScoreTip = "None of this fund's holdings were scored by Equileap, so we can't calculate a score";
      var emptyRankTip = "Less than 1/3 of this fund's holdings were scored by Equileap. When the score coverage is below 33%, we remove the fund from our rankings to increase accuracy";

      switch (gefType) {
        case 'gef_score':
          score = _format2.default.gefScore(scoreValue);
          tip = 'Earned an overall gender-lens score of ' + score + ' out of 100';
          emptyTip = emptyScoreTip;
          units = ' / 100 points';
          break;
        case 'gef_score_a':
          norm = _config2.default.gefScoreNormalizers.balance;
          score = _format2.default.gefScore(scoreValue, norm);
          tip = 'Earned a gender balance score of ' + score + ' out of 100';
          emptyTip = emptyScoreTip;
          units = ' / 100 points';
          break;
        case 'gef_score_b':
          norm = _config2.default.gefScoreNormalizers.policies;
          score = _format2.default.gefScore(scoreValue, norm);
          tip = 'Earned a gender policies score of ' + score + ' out of 100';
          emptyTip = emptyScoreTip;
          units = ' / 100 points';
          break;
        case 'gef_rank':
          norm = _config2.default.gefScoreNormalizers.allScored;
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of all ' + _format2.default.number(norm) + ' funds analyzed scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_rank_a':
          norm = _config2.default.gefScoreNormalizers.allScored;
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of all ' + _format2.default.number(norm) + ' funds analyzed scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_rank_b':
          norm = _config2.default.gefScoreNormalizers.allScored;
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of all ' + _format2.default.number(norm) + ' funds analyzed scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_peer':
          norm = _config2.default.gefScoreNormalizers.peers[fund.morningstar_category_name];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.morningstar_category_name + ' category scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_peer_a':
          norm = _config2.default.gefScoreNormalizers.peers[fund.morningstar_category_name];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.morningstar_category_name + ' category scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_peer_b':
          norm = _config2.default.gefScoreNormalizers.peers[fund.morningstar_category_name];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.morningstar_category_name + ' category scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_grp':
          norm = _config2.default.gefScoreNormalizers.groups[fund.category_group];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.category_group + ' group scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_grp_a':
          norm = _config2.default.gefScoreNormalizers.groups[fund.category_group];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.category_group + ' group scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        case 'gef_grp_b':
          norm = _config2.default.gefScoreNormalizers.groups[fund.category_group];
          score = _format2.default.gefScore(scoreValue, norm, 0, 1);
          tip = score + ' % of ' + _format2.default.number(norm) + ' funds in the ' + fund.category_group + ' group scored the same or lower';
          emptyTip = emptyRankTip;
          units = 'percentile';
          nth = _format2.default.ordinalSuffix(score);
          break;
        default:
          score = null;
          tip = null;
          emptyTip = null;
      }

      score = _format2.default.dropStringTrailingZero(score);

      if (notEmpty === true && score !== null) {
        var stylNm = scoreStyle(score);
        stylNm = units !== 'percentile' ? stylNm + '-border' : stylNm;
        stylNm = this.props.xsmall ? stylNm + '-small' : stylNm;
        return _react2.default.createElement(
          'span',
          {
            styleName: stylNm,
            'data-multiline': true,
            'data-effect': 'solid',
            'data-place': 'bottom',
            'data-for': gefType + '-' + _id,
            'data-html': true,
            'data-tip': _div + tip + div_
          },
          score,
          nth ? _react2.default.createElement(
            'sup',
            null,
            _react2.default.createElement(
              'small',
              null,
              nth
            )
          ) : null,
          '\xA0',
          _react2.default.createElement(
            'small',
            null,
            units
          ),
          _react2.default.createElement(_reactTooltip2.default, { id: gefType + '-' + _id })
        );
      } else {
        return _react2.default.createElement(
          'span',
          {
            styleName: 'no-score',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-place': 'bottom',
            'data-for': 'empty-' + gefType + '-' + _id,
            'data-html': true,
            'data-tip': _div + emptyTip + div_
          },
          _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-ban' }),
          '\xA0',
          emptyTip === emptyScoreTip ? 'Unscored' : 'Unranked',
          _react2.default.createElement(_reactTooltip2.default, { id: 'empty-' + gefType + '-' + _id })
        );
      }
    }
  }]);
  return GenderEqualityScoreLabel;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired,
  gefType: _react.PropTypes.string.isRequired,
  xsmall: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = GenderEqualityScoreLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/GenderEqualityScoreLabel/GenderEqualityScoreLabel.js
// module id = 1343
// module chunks = 0